import { reduxForm } from 'redux-form';
import Component from './UserEditForm';
import { validate, initialValues } from './schema';

const Form = reduxForm({
  form: 'userForm',
  initialValues,
  validate,
})(Component);

export default Form;
